"use client";
import { ModalState, ModalAction } from "./types";
export const modalReducer = (
  state: ModalState,
  action: ModalAction
): ModalState => {
  switch (action.type) {
    case "OPEN_LOGIN_MODAL":
      return {
        modalName: "LOGIN_MODAL",
        isShowing: true,
        actionType: "OPEN_LOGIN_MODAL",
      };
    case "CLOSE_LOGIN_MODAL":
      return {
        modalName: "LOGIN_MODAL",
        isShowing: false,
        actionType: "CLOSE_LOGIN_MODAL",
      };
    default:
      return { modalName: "", isShowing: false, actionType: "" };
  }
};
